module.exports = __webpack_public_path__ + "static/img/ID_card_back.bac01e67.png";